import { useState } from 'react';
import { useApi, useConsulta } from '@plataforma/web/api';
import { mxn } from '../formato';
import { usePuede } from '../permisos';
import { ESTADO_PEDIDO, fechaHora, type Pedido, useFiltro } from './comercial-comun';

// --- Pedidos ---------------------------------------------------------------------------------

/** Pedidos del marketplace y de la tienda: confirmar, preparar, entregar o cancelar. */
export function Pedidos() {
  const api = useApi();
  const permitido = usePuede();
  const [estado, poner] = useFiltro();
  const lista = useConsulta<Pedido[]>(`/commerce/pedidos${estado ? `?estado=${estado}` : ''}`);
  const [error, setError] = useState<string | null>(null);
  const cambiar = async (p: Pedido, siguiente: string) => {
    setError(null);
    const cuerpo: Record<string, string> = { estado: siguiente };
    if (siguiente === 'cancelado') {
      const motivo = window.prompt('Motivo de la cancelación');
      if (!motivo) return;
      cuerpo['motivo'] = motivo;
    }
    try {
      await api('POST', `/commerce/pedidos/${p.id}/estado`, cuerpo);
      lista.recargar();
    } catch (e) {
      setError((e as Error).message);
    }
  };
  return (
    <>
      <div className="encabezado">
        <div>
          <h1>Pedidos</h1>
          <div className="subtitulo">
            Lo apartado se retira de todos los canales hasta entregar o cancelar
          </div>
        </div>
      </div>
      {error && <p className="error">{error}</p>}
      <section className="seccion">
        <header>
          <select value={estado} onChange={(e) => poner(e.target.value)} aria-label="Estado">
            <option value="">Todos</option>
            {Object.entries(ESTADO_PEDIDO).map(([c, t]) => (
              <option key={c} value={c}>
                {t}
              </option>
            ))}
          </select>
        </header>
        {lista.datos && !lista.datos.length ? (
          <p className="vacio">Sin pedidos.</p>
        ) : (
          <table>
            <tbody>
              {(lista.datos ?? []).map((p) => (
                <tr key={p.id}>
                  <td>
                    <strong>{p.folio}</strong> · {p.comprador.nombre}
                    <div className="vin">
                      {[p.comprador.telefono, p.comprador.correo].filter(Boolean).join(' · ')} ·{' '}
                      {p.entrega === 'envio'
                        ? `envío a ${p.direccion?.ciudad ?? '—'}`
                        : 'recoge en sucursal'}{' '}
                      · {fechaHora(p.creadoEn)}
                    </div>
                    <ul style={{ margin: '4px 0 0', paddingLeft: 18 }}>
                      {p.partidas.map((x) => (
                        <li key={x.publicacionId}>
                          {x.titulo} · {mxn(x.precioMxn)}
                        </li>
                      ))}
                    </ul>
                    {p.motivoCancelacion && (
                      <div className="subtitulo">Cancelado: {p.motivoCancelacion}</div>
                    )}
                  </td>
                  <td>
                    <span className={`etiqueta ${p.vencido ? 'aviso' : ''}`}>
                      {p.vencido ? 'Apartado vencido' : ESTADO_PEDIDO[p.estado]}
                    </span>
                  </td>
                  <td className="num">{mxn(p.totalMxn)}</td>
                  <td className="num">
                    {permitido('pedidos.estado') &&
                      p.siguientes.map((s) => (
                        <button key={s} className="boton" onClick={() => void cambiar(p, s)}>
                          {s === 'cancelado' ? 'Cancelar' : ESTADO_PEDIDO[s]}
                        </button>
                      ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </>
  );
}
